import { useState } from "react";
import { ImageOff } from "lucide-react";

// POD thumbnail with a graceful fallback when the stored image can't be rendered.
export function PodThumb({ url, testId = "pod-thumb" }) {
  const [broken, setBroken] = useState(false);
  const full = `${process.env.REACT_APP_BACKEND_URL}${url}`;
  if (broken) {
    return (
      <div className="w-28 h-28 flex flex-col items-center justify-center gap-1 border border-dashed border-[#E5E3DB] rounded text-[#A09E96] text-[11px] text-center px-2" data-testid={`${testId}-fallback`}>
        <ImageOff className="w-5 h-5" />
        POD unavailable
      </div>
    );
  }
  return (
    <a href={full} target="_blank" rel="noreferrer" data-testid={`${testId}-link`}>
      <img src={full} alt="Proof of Delivery" onError={() => setBroken(true)}
        className="w-28 h-28 object-cover border border-[#E5E3DB] rounded hover:opacity-90 transition-opacity" />
    </a>
  );
}

export default PodThumb;
